import { BaseTheme, Typography } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { memo } from 'react'
import { StyledBrowseComponentsButton, SuggestionListActionContainer, SuggestionListActionWrapper } from './styles'

export interface BrowseComponentsDropdownFooterProps {
  onBrowse: () => void
  onAddCustomItem?: () => void
}

const BrowseComponentsDropdownFooter = ({ onBrowse, onAddCustomItem }: BrowseComponentsDropdownFooterProps) => {
  const translate = useTranslate()

  return (
    <SuggestionListActionContainer>
      <SuggestionListActionWrapper>
        <StyledBrowseComponentsButton variant="text" onClick={onBrowse}>
          <Typography textVariant="caption1" colorHex={BaseTheme.palette.blue[900]}>
            {translate("Can't find what you're looking for? Search the full component library")}
          </Typography>
        </StyledBrowseComponentsButton>
        {onAddCustomItem != null && (
          <StyledBrowseComponentsButton variant="text" onClick={onAddCustomItem}>
            <Typography textVariant="caption1" colorHex={BaseTheme.palette.blue[900]}>
              {translate('Add Custom Item')}
            </Typography>
          </StyledBrowseComponentsButton>
        )}
      </SuggestionListActionWrapper>
    </SuggestionListActionContainer>
  )
}

export default memo(BrowseComponentsDropdownFooter)
